import React from "react";

import SEO from "../../src/seo/SEO";

import Hero from "../components/home/Hero";
import TrustedTechnologies from "../components/home/TrustedTechnologies";
import SolutionsOverview from "../components/home/SolutionsOverview";
import CaseStudiesSection from "../components/home/CaseStudiesSection";
import IndustriesSection from "../components/home/IndustriesSection";
import WhyChooseUs from "../components/home/WhyChooseUs";
import FAQSection from "../components/home/FAQSection";
import FinalCTA from "../components/home/FinalCTA";
import WhatsAppFloatingButton from "../components/home/WhatsAppFloatingButton";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

const HomePage = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Bairagi Consultants",
    url: "https://www.bairagi-consultants.com/",
    logo: "https://www.bairagi-consultants.com/logo512.png",
    description:
      "Bairagi Consultants provides custom software development, ecommerce development, mobile app development, CRM, ERP, MIS, AI solutions and business automation services.",
    sameAs: [],
  };

  return (
    <>
      {/* SEO */}
      <SEO
        title="Custom Software Development Company | Bairagi Consultants"
        description="Bairagi Consultants builds custom software, ecommerce platforms, mobile applications, CRM, ERP, MIS, AI solutions and business automation systems for growing businesses."
        path="/"
        schema={organizationSchema}
      />

      {/* HEADER */}
      <Header />

      {/* HERO */}
      <Hero />

      {/* TECHNOLOGIES */}
      <TrustedTechnologies />

      {/* SOLUTIONS */}
      <SolutionsOverview />

      {/* CASE STUDIES */}
      <CaseStudiesSection />

      {/* INDUSTRIES */}
      <IndustriesSection />

      {/* WHY CHOOSE US */}
      <WhyChooseUs />

      {/* FAQ */}
      <FAQSection />

      {/* FINAL CTA */}
      <FinalCTA />

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default HomePage;